import {BaseModel} from "../base/base.model";
export class ClientBanksModel extends BaseModel{
    id: number;
    client_id: number;
    overdraft: number;
    name: string;
    address: string;
    phone: string;
    transit_number: string;
    fi_number: string;
    designation_number: string;
    account_number: string;
    link: string;
    username: string;
    password: string;
}


// WEBPACK FOOTER //
// ./src/app/models/client-banks/client-banks.model.ts